import { DeliveryModes, PractitionerTypes, FacilityTypes } from './schema'

export const healthWellnessScreeningServices = [
  {
    serviceId: 'SCREEN_001',
    serviceName: 'General Health Check',
    category: 'Health & Wellness Screening',
    specialty: null,
    subCategory: 'Preventive Care',
    description: 'Comprehensive annual health assessment and screening',
    cost: 500,
    durationMinutes: 45,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.WORKPLACE],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'SCREEN_HEALTH',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['health check', 'screening', 'preventive'],
    displayOrder: 1
  },
  {
    serviceId: 'SCREEN_002',
    serviceName: 'Insurance Medical Examination',
    category: 'Health & Wellness Screening',
    specialty: null,
    subCategory: 'Insurance Medicals',
    description: 'Medical examination for insurance policy applications',
    cost: 400,
    durationMinutes: 30,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'SCREEN_INSURANCE',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC],
    customisable: true,
    tags: ['insurance', 'medical', 'examination'],
    displayOrder: 2
  },
  {
    serviceId: 'SCREEN_003',
    serviceName: 'Blood Pressure Screening',
    category: 'Health & Wellness Screening',
    specialty: null,
    subCategory: 'Cardiovascular Screening',
    description: 'Blood pressure measurement and cardiovascular risk assessment',
    cost: 80,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT, DeliveryModes.WORKPLACE],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'SCREEN_BP',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.PHARMACY, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['blood pressure', 'screening', 'cardiovascular'],
    displayOrder: 3
  },
  {
    serviceId: 'SCREEN_004',
    serviceName: 'BMI and Body Composition Analysis',
    category: 'Health & Wellness Screening',
    specialty: null,
    subCategory: 'Weight Management',
    description: 'Body mass index calculation and body composition analysis',
    cost: 120,
    durationMinutes: 20,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.WORKPLACE],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'SCREEN_BMI',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['bmi', 'weight', 'composition'],
    displayOrder: 4
  },
  {
    serviceId: 'SCREEN_005',
    serviceName: 'Diabetes Screening',
    category: 'Health & Wellness Screening',
    specialty: null,
    subCategory: 'Diabetes Care',
    description: 'Blood glucose testing and diabetes risk assessment',
    cost: 150,
    durationMinutes: 15,
    deliveryModes: [DeliveryModes.IN_PERSON, DeliveryModes.HOME_VISIT, DeliveryModes.WORKPLACE],
    requiredPractitionerType: PractitionerTypes.NURSE,
    status: 'active',
    billingCode: 'SCREEN_DIABETES',
    billableItems: [
      {
        itemId: 'GLUCOSE_001',
        itemName: 'Glucose test strips',
        itemType: 'consumable'
      }
    ],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.PHARMACY, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['diabetes', 'glucose', 'screening'],
    displayOrder: 5
  },
  {
    serviceId: 'SCREEN_006',
    serviceName: 'Executive Health Assessment',
    category: 'Health & Wellness Screening',
    specialty: null,
    subCategory: 'Executive Health',
    description: 'Comprehensive health assessment package for executives',
    cost: 1200,
    durationMinutes: 120,
    deliveryModes: [DeliveryModes.IN_PERSON],
    requiredPractitionerType: PractitionerTypes.GP,
    status: 'active',
    billingCode: 'SCREEN_EXECUTIVE',
    billableItems: [],
    facilityTypes: [FacilityTypes.CLINIC, FacilityTypes.WELLNESS_CENTER],
    customisable: true,
    tags: ['executive', 'comprehensive', 'assessment'],
    displayOrder: 6
  }
]

export default healthWellnessScreeningServices
